import React from 'react';
import { motion } from 'framer-motion';
import { FaClock, FaStar, FaMapMarkerAlt } from 'react-icons/fa';
import './SpecialPackages.css';

const SpecialPackages = () => {
  const specialTours = [
    { id: 1, title: "Royal Dubai Getaway", days: "5 Days", rating: "4.9", img: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=600" },
    { id: 2, title: "Sacred Char Dham Yatra", days: "11 Days", rating: "5.0", img: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?q=80&w=600" },
    { id: 3, title: "Exotic Maldives Villa", days: "4 Days", rating: "4.8", img: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?q=80&w=600" },
    { id: 4, title: "Paradise of Kashmir", days: "6 Days", rating: "4.9", img: "https://images.unsplash.com/photo-1641580259505-e3aaa26f921d?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
  ];

  // Animation Variants for cleaner code
  const cardVariants = {
    hidden: { opacity: 0, x: 100, scale: 0.9 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 70,
        damping: 12,
        delay: i * 0.15, 
      }
    })
  };

  return (
    <section id="special-packages" className="sp-premium-section">
      <div className="sp-wrapper">
        
        {/* HEADING ANIMATION */}
        <motion.div 
          className="sp-main-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.8 }}
        >
          <motion.span 
            className="sp-mini-tag"
            initial={{ letterSpacing: "0px" }}
            whileInView={{ letterSpacing: "5px" }}
            transition={{ duration: 1 }}
          >
            CHANDRAMA SELECTION
          </motion.span>
          <h2 className="sp-luxury-title">
            Special <span>Tour Packages</span>
          </h2>
          <motion.div 
            className="sp-luxury-line"
            initial={{ width: 0 }}
            whileInView={{ width: "100px" }}
            viewport={{ once: false }}
            transition={{ duration: 1.2, ease: "easeInOut" }}
          ></motion.div>
        </motion.div>

        {/* CARDS GRID - 1 Line 4 Cards */}
        <div className="sp-cards-grid">
          {specialTours.map((tour, index) => (
            <motion.div 
              key={tour.id}
              className="sp-tour-card"
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
              whileHover={{ 
                y: -15, 
                transition: { type: "spring", stiffness: 400, damping: 10 } 
              }}
            >
              <div className="sp-card-img-box">
                <img src={tour.img} alt={tour.title} loading="lazy" />
                <div className="sp-rating-badge">
                  <FaStar /> {tour.rating}
                </div>
              </div>

              <div className="sp-card-content">
                <div className="sp-info-top">
                   <span className="sp-days"><FaClock /> {tour.days}</span>
                   <span className="sp-loc"><FaMapMarkerAlt /> India</span>
                </div>
                <h3>{tour.title}</h3>
                <div className="sp-price-box">
                  {/* <span className="sp-label">Price starts at</span> */}
                  <span className="sp-amount">{tour.price}</span>
                </div>
                <a href="/contact" className="sp-btn-link">
                  <button className="sp-enquire-btn">ENQUIRE NOW</button>
                </a>
              </div>
              <div className="sp-hover-overlay"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpecialPackages;